'use client';
import { isArray, concat, isObject, objectEntries } from '@s7/utils';
import { mergeHeaders } from './core/utils/mergeHeaders.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupported_iterable_to_array(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) {
                return {
                    done: true
                };
            }
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Выполняет глубокое слияние ClientOptions.
 * - Отдельно обрабатывает объекты типа Headers.
 * - Выполняет слияние массивов конкатенацией.
 * */ var mergeOptions = function() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    var result = {};
    var headers = {};
    for(var _iterator = _create_for_of_iterator_helper_loose(sources), _step; !(_step = _iterator()).done;){
        var source = _step.value;
        if (isArray(source)) {
            if (!isArray(result)) {
                result = [];
            }
            result = concat([
                result,
                source
            ]);
        } else if (isObject(source)) {
            // eslint-disable-next-line prefer-const --- Требуется мутировать value
            for(var _iterator1 = _create_for_of_iterator_helper_loose(objectEntries(source)), _step1; !(_step1 = _iterator1()).done;){
                var _step_value = _step1.value, key = _step_value[0], value = _step_value[1];
                if (isObject(value) && key in result) {
                    value = mergeOptions(result[key], value);
                }
                var _obj;
                result = _extends({}, result, (_obj = {}, _obj[key] = value, _obj));
            }
            if (isObject(source.headers)) {
                headers = mergeHeaders(headers, source.headers);
                result.headers = headers;
            }
        }
    }
    return result;
};

export { mergeOptions };
